import React from 'react';
import { Smartphone, Star, Clock, Heart, Users, BookOpen, Radio } from 'lucide-react';
import './PrivacyPolicy.css';

const AboutAmalApp = () => {
  const sections = [
    {
      icon: <Clock size={28} />,
      title: 'روزانہ 7 منٹ کا عہد',
      content: `عمل ایپ کا بنیادی مقصد آپ کی مصروف زندگی میں روحانیت کو شامل کرنا ہے:

• صرف 7 منٹ روزانہ کا وقت درکار
• آسان اور عملی عبادتی معمول
• مسلسل یاد دہانیاں اور حوصلہ افزائی
• خود کار پیش رفت کی پیمائش

یہ مختصر وقت آپ کی پوری زندگی میں مثبت تبدیلی لا سکتا ہے۔`
    },
    {
      icon: <Star size={28} />,
      title: 'آج کی اچھی بات',
      content: `ہر روز ایک نیا حکمت بھرا پیغام:

• قرآن و حدیث سے منتخب اقتباسات
• زندگی کی رہنمائی کے لیے عملی نصائح
• مثبت سوچ اور امید کا پیغام
• اسلامی اخلاقیات کی تعلیم

یہ پیغامات آپ کے دن کو روشن بناتے ہیں اور بہتری کی رہ دکھاتے ہیں۔`
    },
    {
      icon: <BookOpen size={28} />,
      title: 'قرآن اور احادیث',
      content: `مستند اسلامی تعلیمات کا خزانہ:

• قرآن پاک کا اردو ترجمہ اور تفسیر
• صحیح احادیث کا منتخب مجموعہ
• روزانہ ایک رکوع کا گہرائی سے مطالعہ
• مختلف موضوعات پر تقسیم شدہ مواد

تمام مواد علماء کی نگرانی میں تیار کیا گیا ہے۔`
    },
    {
      icon: <Radio size={28} />,
      title: 'آڈیو اور ویڈیو مواد',
      content: `مختلف انداز میں سیکھنے کی سہولت:

• اسلامی ریڈیو اسٹیشن (24/7)
• مختصر تعلیمی ویڈیوز (ریلز)
• مختلف قاریوں کی تلاوت
• نعت اور حمد کا مجموعہ

ہر عمر کے لوگوں کے لیے موزوں مواد دستیاب ہے۔`
    },
    {
      icon: <Users size={28} />,
      title: 'خاندانی تربیت',
      content: `پورے خاندان کے لیے مشترکہ دینی تعلیمی پلیٹ فارم:

• خاندانی گروپس کی تشکیل کی سہولت
• بچوں کے لیے عمر کے مطابق خاص مواد
• والدین کے لیے نگرانی اور کنٹرول کی جامع سہولات
• مشترکہ نیکیوں میں حصہ لینا

ایک ساتھ سیکھنا اور روحانی ترقی حاصل کرنا۔`
    },
    {
      icon: <Heart size={28} />,
      title: 'سنت نبوی صلی اللہ علیہ وسلم',
      content: `رسول اللہ کی پاک سنتوں کا اطلاق:

• روزانہ ایک نئی سنت سیکھنا
• عملی زندگی میں اطلاق کے طریقے
• نبوی اخلاق اور آداب کی تعلیم
• سیرت النبی کے واقعات

حضور صلی اللہ علیہ وسلم کی تعلیمات کو اپنانے کا آسان طریقہ۔`
    }
  ];

  return (
    <div className="privacy-page">
      {/* Hero Section */}
      <div className="page-hero">
        <div className="container">
          <div className="hero-icon">
            <Smartphone size={48} />
          </div>
          <h1>عمل ایپ کے بارے میں</h1>
          <p>آپ کی روحانی زندگی کا مکمل ڈیجیٹل ساتھی</p>
          <div className="last-updated">
            دستیاب: Android اور iOS پر
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="page-content">
        <div className="container">
          <div className="intro-text">
            <p>
              عمل ایپ ایک جامع اسلامی ایپلیکیشن ہے جو آپ کو روزانہ کی بنیادوں پر دینی تعلیمات سے جوڑے رکھتی ہے۔ 
              یہ ایپ خاص طور پر ان لوگوں کے لیے بنائی گئی ہے جو اپنی مصروف زندگی میں اسلامی اقدار کو شامل کرنا چاہتے ہیں۔ 
              صرف 7 منٹ روزانہ کے ساتھ آپ اپنے دین سے قریب ہو سکتے ہیں۔
            </p>
          </div>

          <div className="policy-sections">
            {sections.map((section, index) => (
              <div className="policy-section" key={index}>
                <div className="section-header">
                  <div className="section-icon">
                    {section.icon}
                  </div>
                  <h2>{section.title}</h2>
                </div>
                <div className="section-content">
                  {section.content.split('\n').map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutAmalApp;
